//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Object.js";
import "../CAE/CAE.BaseFEModel.js";
let d=[[],[[[],"CreateReusableObject",{R_:{reusableObject:"Tooling.ReusableObject"}},0,0],[["reuseLibraryName","reusableObject"],"ExportBeamSectionToLibrary",{},2,0],[["reuseLibraryName"],"ImportBeamSectionFromLibrary",{R_:{newSection:"CAE.BeamSection"}},1,0],[["descriptiveName","reuseLibraryName","previewImageFile"],"UpdateDescription",{},3,0]],[]];
SPLM.Tooling.CaeReuseLibrary = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Tooling.CaeReuseLibrary";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;